const MY_REQUESTS_KEY = 'trainings-my-requests'
const MY_TRAININGS_HINT_KEY = 'trainings-my-trainings-hint'
export const TRAINING_SETTINGS_HINT_KEY = 'trainings-settings-hint'

export type Key =
  | typeof MY_REQUESTS_KEY
  | typeof MY_TRAININGS_HINT_KEY
  | typeof TRAINING_SETTINGS_HINT_KEY

export const useGetKeys = () => {
  const getKey = (key: Key) => localStorage.getItem(key)
  const setKey = (key: Key) => localStorage.setItem(key, 'completed')

  return { getKey, setKey }
}
